/**
 * Store for alert callbacks and data.
 * Redux doesn't serialize functions, so we store callbacks here.
 */

type AlertCallback = () => Promise<void> | void;

interface AlertCallbacks {
  callback?: AlertCallback;
  dismissCallback?: AlertCallback;
}

interface AlertData {
  userId?: string;
  organizationId?: string;
  [key: string]: any;
}

let currentCallbacks: AlertCallbacks = {};
let currentData: AlertData = {};

export const alertCallbackStore = {
  set: (callbacks: AlertCallbacks) => {
    currentCallbacks = callbacks;
  },
  get: () => currentCallbacks,
  clear: () => {
    currentCallbacks = {};
  },
  setData: (data: AlertData) => {
    currentData = data;
  },
  getData: () => currentData,
  clearData: () => {
    currentData = {};
  },
  clearAll: () => {
    currentCallbacks = {};
    currentData = {};
  },
};

